import { useAeropayUser } from '@iheartjane/data-access/react-query';
import { useFlag, FLAGS } from '@iheartjane/feature-flags';
import { Button } from '@iheartjane/reefer';
import { EventNames } from '@iheartjane/tracking';
import { useEffect, useState } from 'react';

import { BankLinkingModal } from '@jane/shared-ecomm/components';
import { useCheckout } from '@jane/shared-ecomm/providers';
import { linkBankAccountEvent } from '@jane/shared-ecomm/tracking';
import { getJwt } from '@jane/shared/auth';
import { useJaneUser } from '@jane/shared/data-access';
import { useShouldShowGold } from '@jane/shared/hooks';
import { postMessageToIframeParent } from '@jane/shared/util';

import { PaymentMethods } from '../../util/hooks/usePaymentOptions';
import { useCheckoutPayments } from '../CheckoutPaymentsProvider';

export const JanePayButton = () => {
  const payByBankUI = useFlag(FLAGS.c3PayByBankUI);
  const {
    appInfo: { externalAuth, bloomUserExperience },
    customer: { authenticated, email, nickname },
    guestCheckout: { preAuthSelection, setShowLoginModal, setPreAuthSelection },
    store: { id, jane_pay_integration, photo, state },
  } = useCheckout();
  const shouldShowGold = useShouldShowGold({ store: { id, state } });

  const [modalOpen, setModalOpen] = useState(
    authenticated && preAuthSelection === PaymentMethods.janePay
  );

  const { data: janeUserData } = useJaneUser();
  const { data: aeropayUserData, isFetched } = useAeropayUser({
    janeUserId: janeUserData?.user?.id || null,
    jwt: getJwt(),
  });

  const { updatePrepayments } = useCheckoutPayments();

  useEffect(() => {
    if (aeropayUserData?.bank_accounts.length) {
      const defaultBank =
        aeropayUserData.bank_accounts.find((bank) => bank.is_selected) ||
        aeropayUserData.bank_accounts[0];
      updatePrepayments({ aeropayBankId: defaultBank.bank_account_id });
    }
  }, [aeropayUserData]);

  const handleClick = () => {
    linkBankAccountEvent({
      email: email || '',
      event: EventNames.LinkBankAccountTap,
      isJanePay: true,
      source: 'checkout',
      username: nickname || '',
    });

    if (authenticated) {
      setModalOpen(true);
      return;
    }

    setPreAuthSelection(PaymentMethods.janePay);
    if (externalAuth && bloomUserExperience) {
      postMessageToIframeParent({
        messageType: 'authEvent',
        payload: {
          name: 'initiateExternalAuth',
          source: 'checkout',
        },
      });
    } else {
      setShowLoginModal(true);
    }
  };

  const showButton = !aeropayUserData?.bank_accounts.length || !authenticated;

  const hideBranding = Boolean(jane_pay_integration?.white_label);

  return (
    <>
      {showButton && (
        <Button
          mt={12}
          mb={24}
          full
          label={
            payByBankUI
              ? 'Link bank account'
              : hideBranding
                ? 'Link your bank account'
                : 'Set up Jane Pay'
          }
          onClick={handleClick}
          loading={(modalOpen || !isFetched) && authenticated}
        />
      )}

      {modalOpen && (
        <BankLinkingModal
          open={modalOpen}
          onRequestClose={() => setModalOpen(false)}
          isJanePay
          hideJanePayBranding={hideBranding}
          location="checkout"
          storePhoto={photo || undefined}
          isGold={shouldShowGold}
        />
      )}
    </>
  );
};
